import ua from 'universal-analytics';
import appConfig from '../config/appConfig';
import logger from '../utils/logger';

const logTag = '[AnalyticsManager]';
const visitor = ua(appConfig.analyticsCode);
const appName = 'ojicho-vr';
const appVersion = appConfig.appVersion;
const useScreenView = false;
const hostname = location.hostname;
const enabled = appConfig.analyticsCode != null;

if (!enabled) {
  logger.info(`${logTag} disabled`);
}

class AnalyticsManager {

  sendWelcome() {
    if (!enabled) return;
    logger.info(`${logTag} sendWelcome`);
    if (useScreenView) {
      visitor.screenview('Welcome Screen', appName, appVersion).send();
    } else {
      visitor.pageview({
        dp: '/',
        dt: 'Welcome Screen',
        dh: hostname,
      }).send();
    }
  }


  sendLanguage(language, action) {
    if (!enabled) return;
    logger.info(`${logTag} sendLanguage`, language, action);
    visitor.event({
      ec: 'Language',
      ea: action,
      el: language,
      dh: hostname,
    }).send();
  }


  sendPanorama(panoramaId, name) {
    if (!enabled) return;
    logger.info(`${logTag} sendPanorama`, panoramaId, name);
    if (useScreenView) {
      visitor.screenview(panoramaId + ' -- ' + name, appName).send();
    } else {
      visitor.pageview({
        dp: '/' + panoramaId,
        dt: name,
        dh: hostname,
      }).send();
    }
  }


  sendVideo(content, action) {
    if (!enabled) return;
    logger.info(`${logTag} sendVideo`, content, action);
    visitor.event({
      ec: 'Video',
      ea: action,
      el: content,
      dh: hostname,
    }).send();
  }


  sendProduct(productId, action) {
    if (!enabled) return;
    logger.info(`${logTag} sendProduct`, productId, action);
    visitor.event({
      ec: 'Product',
      ea: action,
      el: productId,
      dh: hostname,
    }).send();
  }


  sendBooking() {
    if (!enabled) return;
    logger.info(`${logTag} sendBooking`);
    visitor.event({
      ec: 'Booking',
      ea: 'click',
      el: '体験予約はこちら',
      dh: hostname,
    }).send();
  }

}

export default new AnalyticsManager();